
import * as app from '../components/app';
import * as crud from '../components/crud';
import * as etc from '../components/etc';
import * as pages from '../views';


import store from '@/store'
export default [
  {
    path: '/',
    component: app.Main,
    name: 'main',
    meta: { requiresAuth: true },
    children: [
      {
        path: '/dash',
        component: app.Dash,
        name: 'dash'
      }, {
        path: '/setting',
        component: app.Setting,
        name: 'setting'
      }, {
        path: '/list/:objNm/:page?',
        component: crud.Table,
        name: 'list'
      }, {
        name: "editObj",
        path: '/edit/:objNm/:uid',
        meta: {
          detail: 'edit'
        },
        component: crud.Detail
      }, {
        name: "detailObj",
        path: '/detail/:objNm/:uid',
        meta: {
          detail: 'view'
        },
        component: crud.Detail
      }, {
        name: 'newObj',
        path: '/new/:objNm',
        meta: {
          detail: 'new'
        },
        component: crud.Detail
      }, {
        name: 'video',
        path: '/video/:objNm/:page?',
        component: etc.Video
      }, {
        name: 'test',
        path: '/test',
        component: etc.Test
      }
    ]
  },
  {
    path: '/main',
    component: app.Main
  },
  {
    path: '/login',
    component: pages.Login,
    beforeEnter: (to, from, next) => {
      if (store.state.auth.user) {
        return next('/')
      }
      next()
    }
  },
  {
    path: '*',
    redirect: '/'
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js